
import Vue from "vue";
import Component from "vue-class-component";
import LoaderContainer from "@/components/Loader.vue";
import { moneyFormatter } from "@/components/utils";
import { situacaoPedidoMap } from "@/components/utils";
import imageService from "@/services/ImageService";

@Component({
  name: "DetalhesPedidoContainer",
  components: {
    LoaderContainer,
  },
  props: {
    pedido: {
      required: true,
      default: () => ({}),
    },
  },
})
export default class DetalhesPedidoContainer extends Vue {
  private situacaoPedidoMap = situacaoPedidoMap;
  private moneyFormatter = moneyFormatter;

  private headers = [
    { text: 'Imagem', value: 'imagem', sortable: false },
    { text: 'Código', value: 'produto.id' },
    { text: 'Produto', value: 'produto.descricao_portal' },
    { text: 'Unidade', value: 'unidadeMedida' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'Preço Unit.', value: 'valorUnit' },
    { text: 'Total', value: 'valorTotal' }
  ]

  private headersTroca = [
    { text: 'Imagem', value: 'imagem', sortable: false },
    { text: 'Código', value: 'produto.id' },
    { text: 'Produto', value: 'produto.descricao_portal' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'Preço Unit.', value: 'valorUnit' },
  ]

  private activeTab = 0;

  get dataPedido() {
    const dt = new Date(this.$props.pedido?.data?.replace('Z', ''));
    return dt.toLocaleString();
  }

  get valorPedido() {
    return moneyFormatter(this.$props.pedido?.valorTotal);
  }

  get resumoPedido() {
    const qtdeTotal =
      this.$props.pedido?.produtos?.reduce(
        (result, current) => +result + +current.quantidade,
        0
      ) || 0;
    const qtdeProds = this.$props.pedido?.produtos?.length;

    return `${qtdeTotal} Ite${
      qtdeTotal > 1 ? "ns" : "m"
    } / ${qtdeProds} Produto${qtdeProds > 1 ? "s" : ""}`;
  }

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  buildProdutoImage(produtoPedido: any) {
    const imgs = imageService.getProdutoImages(produtoPedido.produto)[0];
    const result = {
      src: imgs.img,
      "lazy-src": imgs.thumb,
    };
    return result;
  }
}
